import Icon, { ICONSIZE } from '../../../../../../../presentation/components/Icon';
import deviceIcon from '../../../../../../assets/icons/png/3x/status-display@3x.png';
import checkmarkIcon from '../../../../../../assets/icons/png/3x/circle-check-info@3x.png';
import TableEntry from '../../TableEntry';
import React from 'react';
import { useMediaQuery } from 'tools/hooks/useMediaQuery';
import { useTranslation } from 'react-i18next';

const MeasuringDevices = () => {
  const isAboveXXS = useMediaQuery('(min-width: 376px)');
  const { t } = useTranslation();

  return (
    <TableEntry
      leftValues={[
        t('pageSummaryBasicServicesSectionLabelMeasuringDevicesTitle'),
        t('pageSummaryBasicServicesSectionLabelMeasuringDevicesContent')
      ]}
      startElement={
        <Icon iconSrc={deviceIcon} size={ICONSIZE.medium} alt="measuring devices icon" />
      }
      endElement={
        <Icon iconSrc={checkmarkIcon} size={ICONSIZE.small} centered alt="checkmark icon" />
      }
      additionalClassNames={isAboveXXS ? '' : 'px-0'}
    />
  );
};

export default MeasuringDevices;
